import { useEffect, useState } from "react";
import API_URL from "../../API";
import { EVENT_ID_MAP } from "../schedules";

export const useEventCities = (activeEventId) => {
  const [eventsData, setEventsData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllEvents = async () => {
      setIsLoading(true);
      try {
        const eventIds = Object.values(EVENT_ID_MAP);
        const results = await Promise.all(
          eventIds.map(async (id) => {
            try {
              const response = await API_URL.eventUrl.get(
                `world-education-festival/master-event/${id}`
              );

              const sortedEvents = (response?.data?.data?.event_lokasi || [])
                .sort((a, b) => new Date(a.time_event) - new Date(b.time_event))
                .map((item) => ({
                  ...item,
                  nama_kota: item.kabupaten?.nama_kabkota || "Unknown",
                  date_kota: item.time_event || "Unknown",
                }));

              const now = new Date();
              // Check if all cities for this event have dates in the past
              const isExpired = sortedEvents.length > 0 && sortedEvents.every(
                (city) => city.time_event && new Date(city.time_event) < now
              );

              return { id, cities: sortedEvents, isExpired };
            } catch (error) {
              console.error(`Error fetching event ${id}:`, error);
              return { id, cities: [], isExpired: false };
            }
          })
        );

        const dataMap = results.reduce((acc, curr) => {
          acc[curr.id] = { cities: curr.cities, isExpired: curr.isExpired };
          return acc;
        }, {});

        setEventsData(dataMap);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllEvents();
  }, []);

  const activeData = eventsData[activeEventId] || { cities: [], isExpired: false };

  return {
    cities: activeData.cities,
    isLoading,
    eventsData,
  };
};